import PropTypes from 'prop-types'
import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import { DUAL_PANEL_SELECTABLE_TYPES, PER_PAGE } from '../../../../../../constants/dual-panel-selector-constants'
import DualPanelSelector from '../../../../../common/dual-panel-selector/DualPanelSelector'
import { selectProgramsData, setSearchValue } from '../../../../../../reducers/dualPanelSelectorReducer'
import classnames from 'classnames'
import Modal from '../../../../../common/Modal'
import SubmitButton from '../../../../../common/buttons/SubmitButton'

import classes from './WaitlistProgramSelectorModal.module.scss'
import { ReactComponent as PersonIcon } from '../../../../../../assets/images/common/icons/person-icon.svg'
import { getProgramsDualPanelSelectorThunk } from '../../../../../../actions/programActions'
import { categoryCompare } from '../../../../../../utility/programHelper'

const SummaryPlaceholder = () => (
  <div className={classes.placeholder}>
    <PersonIcon className={classes.icon} />
    <p className={classes.title}>No New Students Added</p>
    <p className={classes.description}>
      All Students Present will be disabled...
    </p>
  </div>
)

const WaitlistProgramSelectorModal = ({
  title,
  onProceed,
  currentProgram,
  selectedProgram,
  selectedStudent,
  onSelectProgram,
  ...props
}) => {
  const dispatch = useDispatch()
  const programsData = useSelector(selectProgramsData)

  const fetchPrograms = useCallback((page, searchTerm, completed) =>
    dispatch(getProgramsDualPanelSelectorThunk({ page, perPage: PER_PAGE, searchTerm, completed }))
      .unwrap()
      .catch(() => toast.error('Something went wrong. Please try again.', { position: toast.POSITION.TOP_RIGHT }))
  , [dispatch])

  const leftPanelProps = {
    tabTypes: [DUAL_PANEL_SELECTABLE_TYPES.programs],
    tabProps: {
      [DUAL_PANEL_SELECTABLE_TYPES.programs]: {
        titleText: 'Select the program you\'d like to enroll this student in',
        allItems: programsData.items.filter(program => program.id !== currentProgram.id),
        withCompletedSwitcher: false,
        searchValue: programsData.searchValue,
        onSearchValueChange: (searchValue) => dispatch(setSearchValue({ searchValue, key: DUAL_PANEL_SELECTABLE_TYPES.programs })),
        getSelectedItem: (id) => selectedProgram?.id === id ? selectedProgram : undefined,
        fetchItems: fetchPrograms,
        pagination: programsData.pagination,
        onCheckChange: (checked, program) => onSelectProgram(checked ? null : program),
        itemCategoryTitle: (program) => program.category ? program.category.name : 'Other Programs',
        itemCategoryCompare: categoryCompare,
        isLoading: programsData.isLoading,
      },
    },
  }

  const rightPanelProps = {
    selectedItems: [selectedStudent],
    selectedItemType: DUAL_PANEL_SELECTABLE_TYPES.students,
    summaryPlaceholder: <SummaryPlaceholder />,
  }

  return (
    <Modal className={classes.modal} title={title} {...props}>
      <div className={classnames('d-flex flex-column', classes.modalContentWrapper)}>
        <DualPanelSelector
          type='WaitlistProgramRoster'
          className={classes.dualPanelSelector}
          {...leftPanelProps}
          {...rightPanelProps}
        />
        <div className='mt-3 d-flex justify-content-end'>
          <SubmitButton
            disabled={!selectedProgram}
            className={classes.button}
            buttonMessage='Continue'
            onClick={onProceed}
          />
        </div>
      </div>
    </Modal>
  )
}

WaitlistProgramSelectorModal.propTypes = {
  title: PropTypes.string,
  isOpen: PropTypes.bool,
  currentProgram: PropTypes.object.isRequired,
  selectedProgram: PropTypes.object,
  selectedStudent: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  onProceed: PropTypes.func.isRequired,
  onSelectProgram: PropTypes.func.isRequired,
}

export default WaitlistProgramSelectorModal
